<template>
  <div class="maintenance-container">
    <div class="maintenance-content">
      <div class="maintenance-icon">
        🔧
      </div>
      <h1 class="maintenance-title">Sedang Maintenance</h1>
      <p class="maintenance-description">
        Halaman ini sedang dalam tahap pengembangan atau perbaikan.
        <br>
        Silakan kembali lagi nanti atau hubungi administrator.
      </p>
      <div class="maintenance-actions">
        <button @click="goBack" class="back-btn">
          ← Kembali
        </button>
        <button @click="goHome" class="home-btn">
          🏠 Beranda
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceView',
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.maintenance-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.maintenance-content {
  background: white;
  border-radius: 16px;
  padding: 48px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
}

.maintenance-icon {
  font-size: 72px;
  margin-bottom: 24px;
  animation: rotate 3s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.maintenance-title {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
}

.maintenance-description {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 32px 0;
}

.maintenance-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.back-btn,
.home-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-btn {
  background: #6b7280;
  color: white;
}

.back-btn:hover {
  background: #4b5563;
  transform: translateY(-2px);
}

.home-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
}

.home-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-2px);
}

/* Responsive design */
@media (max-width: 768px) {
  .maintenance-content {
    padding: 32px 24px;
  }
  
  .maintenance-title {
    font-size: 24px;
  }
  
  .maintenance-description {
    font-size: 14px;
  }
  
  .maintenance-icon {
    font-size: 56px;
  }
  
  .maintenance-actions {
    flex-direction: column;
  }
  
  .back-btn,
  .home-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .maintenance-container {
    padding: 16px;
  }
  
  .maintenance-content {
    padding: 24px 16px;
  }
  
  .maintenance-title {
    font-size: 20px;
  }
  
  .maintenance-description {
    font-size: 13px;
  }
  
  .maintenance-icon {
    font-size: 48px;
  }
}
</style>